import TemporaryRedirect from './temporary_redirect';
export default TemporaryRedirect;
